import { ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import TextField from 'components/forms/textField/TextField';
import useGetCurrencySymbol from 'hooks/useGetCurrencySymbol';
import { Currency } from 'models/Currency';

const PropertyNightlyBasePriceField = ({
  currency,
  label,
  name = 'propertyPricingFeesTaxes.nightlyBasePrice',
}: {
  currency: Currency;
  label?: ReactNode;
  name?: string;
}) => {
  const getCurrencySymbol = useGetCurrencySymbol();
  const { t } = useTranslation();

  return (
    <TextField
      label={label ?? t('pageProperty.pricing.priceSettings.nightlyBasePrice')}
      name={name}
      colSmInput={7}
      colSmLabel={5}
      leftAddon={getCurrencySymbol(currency)}
      rightTooltip={
        <Trans
          i18nKey="pageProperty.pricing.priceSettings.nightlyBasePriceTooltip"
          components={{
            link1: (
              <a
                aria-label="Hostfully documentation"
                href="https://help.hostfully.com/en/articles/1844391-configure-pricing"
                target="_blank"
                rel="noreferrer"
              />
            ),
          }}
        />
      }
      type="number"
      required
    />
  );
};

PropertyNightlyBasePriceField.defaultProps = {
  label: undefined,
  name: undefined,
};

export default PropertyNightlyBasePriceField;
